/**
 * 홈페이지 메인 배너 컴포넌트
 * 상단에 표시되는 히어로 이미지 배너입니다.
 */

import styled from 'styled-components';
import mainBanner from '../../assets/newImage/main_web@2x.png';
import mainBannerMobile from '../../assets/newImage/main_mobile@3x.png';

/**
 * HeroBanner 컴포넌트
 * 접근성을 위한 숨김 텍스트를 포함한 메인 배너를 렌더링합니다.
 */
function HeroBanner() {
  return (
    <KeyBox>
      <KeyImage>
        <KeyText>
          <HiddenText>
            도움의 손길이 필요할 때, 중구행복돌봄센터가 함께하겠습니다.
          </HiddenText>
        </KeyText>
      </KeyImage>
    </KeyBox>
  );
}

export default HeroBanner;

/* Styled Components */

const HiddenText = styled.p`
  position: absolute;
  overflow: hidden;
  top: 0;
  visibility: hidden;
  width: 1px;
  height: 1px;
`;

const KeyBox = styled.div`
  /* 데스크톱 기본 스타일 */

  height: 503px;
  background: #fcf5f4;
  display: flex;
  align-items: center;

  &::after {
    display: block;
    clear: both;
  }

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    height: auto;
    padding: 20px 0;
  }
`;

const KeyImage = styled.div`
  /* 데스크톱 기본 스타일 */
  position: relative;
  width: 1020px;
  height: 362px;
  background: #fcf5f4 url(${mainBanner}) no-repeat;
  background-size: 100% 100%;
  margin: auto auto;

  &::after {
    display: block;
    clear: both;
  }
  @media (max-width: 768px) {
    background-image: url(${mainBannerMobile});
    background-size: cover; /* 필요시 조정 */
    background-position: center;
    width: 100%;
    height: 250px;
  }
  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    width: 80%;
    height: 230px;
    background-size: 100% 200px;
    margin-bottom: 20px;
  }

  @media (max-width: 375px) {
    height: 180px;
    background-size: 100% 150px;
    margin-bottom: 10px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    height: 300px;
    background-size: 100% 280px;
    margin-bottom: 30px;
  }
`;

const KeyText = styled.div`
  /* 데스크톱 기본 스타일 */
  position: relative;
  width: 1020px;
  height: 503px;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    width: 100%;
    height: auto;
  }
`;
